module.exports = __webpack_public_path__ + "img/jb_t3411_53-1994.prt.a80ccb2b.jpg";